import React from 'react';
import { RefreshCw } from 'lucide-react';
import { GenericButton } from '../../../../../ui-components/Button/GenericButton';

interface RefreshButtonProps {
  onRefresh: () => void;
  loading: boolean;
}

/**
 * Refetches CPR + neighbor data. Icon-only in the single-row toolbar, so the accessible name has
 * to come from `aria-label` / `title` — without them the control would be unlabelled to screen
 * readers and unexplained on hover.
 */
export const RefreshButton: React.FC<RefreshButtonProps> = ({ onRefresh, loading }) => (
  <GenericButton
    variant="secondary"
    shape="filled"
    size="sm"
    isIconOnly
    icon={<RefreshCw size={14} className={loading ? 'animate-spin' : ''} />}
    aria-label="Refresh BGP data"
    title="Refresh BGP data"
    onClick={onRefresh}
    disabled={loading}
  />
);
